/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { image64toCanvasRef } from '../utils/helpers';
import './DokanDropZone.css';
import DokanIcons from './icon/DokanIcons';
import DokanModal from './modal/DokanModal';

const DokanDropZone = () => {
    const [fileSrc, setFileSrc] = useState(null);
    const [finalImageSrc, setFinalImgSrc] = useState(null);
    const [crop, setCrop] = useState({
        aspect: 16 / 9,
        width: 50,
    });
    const imagePreviewCanvasRef = useRef();

    const fileMaxSize = 1000000000; // byte
    const acceptedFileTypes = 'image/x-png, image/png, image/jpg, image/jpeg, image/gif';
    const acceptedFileTypesArray = acceptedFileTypes.split(',').map((item) => item.trim());

    const verifyUploadedFile = (files) => {
        if (files && files.length > 0) {
            const currentFile = files[0];
            const currentFileType = currentFile.type;
            const currentFileSize = currentFile.size;

            if (currentFileSize > fileMaxSize) {
                // alert('File is too large');
                return false;
            }
            if (!acceptedFileTypesArray.includes(currentFileType)) {
                // alert('File Type Not Allowed');
                return false;
            }
            console.log('verified');
            return true;
        }
    };
    const handleOnDrop = (files, rejectedFiles) => {
        console.log('droped', files);
        console.log('rejected', rejectedFiles);

        if (rejectedFiles && rejectedFiles.length > 0) {
            verifyUploadedFile(rejectedFiles);
        }

        if (files && files.length > 0) {
            const isVerified = verifyUploadedFile(files);
            if (isVerified) {
                console.log(files);
                // imageBase64
                const currentFile = files[0];
                console.log(currentFile, 'cur');
                const reader = new FileReader();
                reader.addEventListener(
                    'load',
                    () => {
                        setFileSrc(reader.result);
                    },
                    false
                );
                reader.readAsDataURL(currentFile);
                setVisible(true);
            }
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        multiple: false,
        accept: acceptedFileTypes,
        maxSize: fileMaxSize,
        onDrop: handleOnDrop,
    });

    const handleOnCropChange = (croppedData) => {
        console.log('crop data', croppedData);
        setCrop(croppedData);
    };
    const handleImageLoaded = (image) => {
        // setCrop({ width: image.width, height: image.height });
        // return false;
    };
    // eslint-disable-next-line no-shadow
    const handleOnCropComplete = (c, pixelCrop) => {
        const canvasRef = imagePreviewCanvasRef.current;
        const imgSrc = fileSrc;
        image64toCanvasRef(canvasRef, imgSrc, pixelCrop);
        setFinalImgSrc(imgSrc);
        console.log('handile cropcom', c);
        console.log(pixelCrop);
        console.log(finalImageSrc);
    };

    const [visible, setVisible] = useState(false);
    const showModal = () => {
        setVisible(true);
    };
    // console.log(fileSrc.width);

    return (
        <div className="react_image_drop_section">
            <div {...getRootProps({ className: 'react_image_drop_zone' })}>
                {fileSrc ? (
                    <div className="react_image_drop_zone_inner">
                        <input {...getInputProps()} />
                        <canvas ref={imagePreviewCanvasRef} height="400">
                            {' '}
                        </canvas>
                    </div>
                ) : (
                    <div className="react_image_drop_zone_inner">
                        <input {...getInputProps()} />
                        <DokanIcons icon="#upload" size={10} />
                        <p>Drag and drop some files here, or click to select files</p>
                    </div>
                )}
                {/* <img src={fileSrc} /> */}
            </div>
            <DokanModal visible={visible} setVisible={setVisible} modalTitle="Crop Image">
                <ReactCrop
                    // locked
                    src={fileSrc}
                    crop={crop}
                    onChange={(croppedData) => handleOnCropChange(croppedData)}
                    onImageLoaded={(image) => handleImageLoaded(image)}
                    onComplete={(c, pixelCrop) => handleOnCropComplete(c, pixelCrop)}
                />
            </DokanModal>
        </div>
    );
};

export default DokanDropZone;
